import { render, staticRenderFns } from "./ModalSignUp.vue?vue&type=template&id=3788657c&"
import script from "./ModalSignUp.vue?vue&type=script&lang=js&"
export * from "./ModalSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoWithTradeMark: require('/home/circleci/repo/components/LogoWithTradeMark.vue').default})
